// @flow

const filterNameSearch = (searchTarget) => {
	return ({ vendor }) =>
		vendor?.name?.toLowerCase()?.includes(searchTarget?.toLowerCase())
}

export default filterNameSearch
